/* @flow */
/* eslint-env es6,browser */
export const IDP_COOKIE_EXPIRY_DAYS = 30;

export const IDP_COMMONID = 'pubcommonid';
export const IDP_LIVERAMP = 'liveramp';
export const IDP_PUBMATIC = 'pubmatic';
export const IDP_VZM = 'verizon';

/* User ID Module Keys */
export const USER_ID_CRITEO = 'criteo';
export const USER_ID_PUBCOMMON = 'pubcommon';
export const USER_ID_LIVERAMP = 'liveramp';
export const USER_ID_FABRICK = 'fabrick';
export const USER_ID_VERIZON = 'verizon';
